export class PeriodsHttp {
    /**
     * Get Period by date
     * @param date
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getPeriodByDate(date) {
        try {
            return await window.axios.get(`periods/${date}`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Get all periods
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getPeriods() {
        try {
            return await window.axios.get(`periods`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Create a new period
     * @param period
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async createNewPeriod(period) {
        try {
            return await window.axios.post(`periods`, period);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Update a period
     * @param period
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async updatePeriod(period) {
        try {
            return await window.axios.put(`periods`, period);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Archive a period
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async archivePeriod(id) {
        try {
            return await window.axios.delete(`periods/${id}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }
}
